<template>
  <v-dialog
    :value="value"
    scrollable
    fullscreen
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card>
      <v-card-title>
        {{$t("dialogs.segmentTimePair.title")}}
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider/>

      <v-card-text class="pa-2">
        <div class="subtitle-1 text-end my-1">
          <v-spacer/>
          <slot name="subtitle-actions"/>
        </div>
        <SegmentTimePairTable
          :headers="headers"
          :items="items"
          id="segmentTimePairTableDialog"
        >
          <template v-slot:startDate="{ item }">
            <slot name="startDate" v-bind:item="item"></slot>
          </template>
          <template v-slot:clockIn="{ item }">
            <slot name="clockIn" v-bind:item="item"></slot>
          </template>
          <template v-slot:clockOut="{ item }">
            <slot name="clockOut" v-bind:item="item"></slot>
          </template>
          <template v-slot:actions="{ item }">
            <slot name="actions" v-bind:item="item"/>
          </template>
        </SegmentTimePairTable>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SegmentTimePairTable from '@/components/timepairs/SegmentTimePairTable.vue';

import getTableFooterProps from '@/mixins/getTableFooterProps';
import attachMobileBackButton from '@/mixins/attachMobileBackButton';

export default {
  name: 'SegmentTimePairTableDialog',

  components: { SegmentTimePairTable },

  mixins: [attachMobileBackButton, getTableFooterProps],

  props: {
    value: Boolean,
    headers: Array,
    items: Array,
  },
};
</script>

<style scoped>
>>>.v-data-table-header-mobile {
  display: none;
}
</style>
